// Protezione contro le mutazioni del DOM fatte da autofill del browser,
// password manager e estensioni (traduttore di pagina, Grammarly, ...).
// Quando un nodo è già stato spostato o rimosso da loro, React tenta comunque
// removeChild/insertBefore e lancia "Failed to execute 'removeChild' on 'Node'",
// facendo cadere l'intera app nell'ErrorBoundary (caso reale: pagina di login
// con credenziali salvate). Qui l'operazione impossibile viene ignorata.
if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function removeChildSafe(child) {
    if (child && child.parentNode !== this) return child;
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function insertBeforeSafe(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) return newNode;
    return originalInsertBefore.apply(this, arguments);
  };
}
